// src/utils/stripe/stripeConfig.ts
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { checkFinanceIntegrationForCompany } from "../../api/admin/integrationApi";

let stripePromise: Promise<Stripe | null> | null = null;

/**
 * Get Stripe instance with publishable key from environment
 * CRITICAL: Never expose secret keys in frontend code
 */
export const getStripe = async (): Promise<Stripe | null> =>  {
	if (!stripePromise) {
		let publicKey: string;
		({ publicKey } = await checkFinanceIntegrationForCompany());
		

		if (!publicKey) {
			console.error("Stripe publishable key not found in environment variables");
			return Promise.resolve(null);
		}

		stripePromise = loadStripe(publicKey);
	}

	return stripePromise;
};

/**
 * Format Stripe amount (convert from cents to dollars)
 */
export const formatStripeAmount = (amountInCents: number, currency: string = "AUD"): string => {
	const amount = amountInCents / 100;
	return new Intl.NumberFormat("en-AU", {
		style: "currency",
		currency,
	}).format(amount);
};

/**
 * Convert dollar amount to Stripe cents
 */
export const toStripeAmount = (amount: number): number => {
	return Math.round(amount * 100);
};

/**
 * Get payment method icon based on card brand
 */
export const getCardIcon = (brand: string): string => {
	const icons: Record<string, string> = {
		visa: "💳",
		mastercard: "💳",
		amex: "💳",
		discover: "💳",
		diners: "💳",
		jcb: "💳",
		unionpay: "💳",
	};
	return icons[brand.toLowerCase()] || "💳";
};

/**
 * Format card details for display
 */
export const formatCardDisplay = (brand: string, last4: string): string => {
	return `${brand.toUpperCase()} •••• ${last4}`;
};

/**
 * Get status color for Stripe payment status
 */
export const getStripeStatusColor = (status: string): string => {
	const colors: Record<string, string> = {
		succeeded: "green",
		processing: "blue",
		requires_payment_method: "gold",
		requires_confirmation: "gold",
		requires_action: "gold",
		canceled: "default",
		failed: "red",
	};
	return colors[status] || "default";
};